import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LayoutModule } from "@angular/cdk/layout";

import { DataTablesModule } from "angular-datatables";
import { DefaultModule } from "./layout/default.module";
import { MaterialModule } from "./material.module";
import { MonacoEditorModule } from "ngx-monaco-editor";

import { JwtInterceptor, ErrorInterceptor } from "./helpers";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

//import { DefaultComponent } from './layout/default.component';
// import { AlertComponent } from './alert';

//import { MatIconRegistry } from '@angular/material/icon';
// import { MatToolbarModule } from '@angular/material/toolbar';
// import { MatButtonModule } from '@angular/material/button';
// import { MatSidenavModule } from '@angular/material/sidenav';
// import { MatIconModule } from '@angular/material/icon';
// import { MatListModule } from '@angular/material/list';

// import { ClientesComponent } from './clientes/clientes.component';
// import { ClienteDetailComponent } from './clientes/cliente-detail/cliente-detail.component';
// import { FluxosComponent } from './fluxos/fluxos.component';
// import { FluxoDetailComponent } from './fluxos/fluxo-detail/fluxo-detail.component';
// import { ConfigComponent } from './config/config.component';
// import { ConfigDetailComponent } from './config/config-detail/config-detail.component';
// import { ExesModule } from './exes/exes.module';
//import { ConfigModule } from './config/config.module';

// decorator: gera items adicionais para a classe "AppModule"
@NgModule({
  declarations: [
    AppComponent,
    //AlertComponent,
    //DefaultComponent,
    // ClientesComponent,
    // ClienteDetailComponent,
    // FluxosComponent,
    // FluxoDetailComponent,
    // ConfigComponent,
    // ConfigDetailComponent
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    AppRoutingModule,
    DefaultModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    LayoutModule,
    //MatIconRegistry,
    MonacoEditorModule.forRoot(),
    NgxDaterangepickerMd,
    NgbModule,
    // ExesModule,
    //ConfigModule
  ],
  // exports: [
  //   MatIconModule,
  //   //MatIconRegistry
  // ],
  //providers: [ClientesComponent, FluxosComponent],
  // providers: [ClientesComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt-pt' }  
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
